import { GridColumn } from '../../../types';

export const getIsBooleanColumnFilter = (column: GridColumn): boolean => {
  const controlType = column.filterItem?.control?.type;
  return controlType ? controlType === 'checkbox' : column.type === 'boolean';
};
